import RawMaterialMaster from "../models/RawMaterialMaster";
import MaterialNumber from '../models/MaterialNumber';
import RawMaterialGroup from '../models/RawMaterialGroup';
import apiClient from "../components/apiClient";

export class RawMaterialMasterService {
    static getMasterRawMaterials() : Promise<RawMaterialMaster[]> {
        return apiClient.get<RawMaterialMaster[]>(`/RawMaterialMaster/GetMasterRawMaterials`).then(res => res.data);
    }

    static getMaterialNumbers() : Promise<MaterialNumber[]> {
        return apiClient.get<MaterialNumber[]>(`/RawMaterialMaster/GetMaterialNumbers`).then(res => res.data);
    }

    static getRawMaterialGroupsByMaterialNumber(materialNumber: string) : Promise<RawMaterialGroup[]> {
        return apiClient.get<RawMaterialGroup[]>(`/RawMaterialMaster/GetRawMaterialGroupsByMaterialNumber/${materialNumber}`).then(res => res.data);
    }
}